export const naturalPersonDocumentsList = [
  {
    label: 'Documento de identificação',
    download_key: 'identification_url',
    upload_key: 'OTHER',
  },
  {
    label: 'Comprovante de endereço',
    download_key: 'proof_of_address_url',
    upload_key: 'PROOF_OF_ADDRESS',
  },
];

export enum EPersonDocument {
  PROFF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  IDENTIFICATION = 'OTHER',
}
